<div class="mfa-challenge">
  @if ((multiFactorInProgress$ | async) === false) {
    <div
      class="mfa-challenge__options"
      >
      <p class="message">To verify your identity, Clear Sign will send you a security code.</p>
      <h4>Please select where to send your security code</h4>
      <div class="form-container">
        <form class="typeform rkt-Fieldset">
          <mat-radio-group>
            <div>
              @if(packageUser.phoneNumber !== null) {
                <div>
                  <mat-radio-button
                    (change)="change($event)"
                    [checked]="packageUser?.phoneNumber"
                    [value]="multiFactorChallengeOptions.SMS"
                    class="rkt-Radio"
                    id="SMS"
                    name="selectedChallengeType"
                    >
                    <span data-testid="mfa-sms"> Text to (***) ***-{{ packageUser.phoneNumber }} </span>
                  </mat-radio-button>
                </div>
                <div>
                  <mat-radio-button
                    (change)="change($event)"
                    [value]="multiFactorChallengeOptions.PHONE"
                    class="rkt-Radio"
                    id="PhoneCall"
                    name="selectedChallengeType"
                    >
                    <span data-testid="mfa-phonecall">
                      Call to (***) ***-{{ packageUser.phoneNumber }}
                    </span>
                  </mat-radio-button>
                </div>
                } @if(packageUser.emailAddress !== null) {
                <div>
                  <mat-radio-button
                    (change)="change($event)"
                    [checked]="!packageUser?.phoneNumber"
                    [value]="multiFactorChallengeOptions.EMAIL"
                    class="rkt-Radio"
                    id="Email"
                    name="selectedChallengeType"
                    >
                    <span data-testid="mfa-email"> Email to {{ packageUser.emailAddress }} </span>
                  </mat-radio-button>
                </div>
              }
            </div>
          </mat-radio-group>
        </form>
        @if (errorMessage$ | async; as errorMessage) {
          <div class="error mfa-challenge__error">
            {{ errorMessage }}
          </div>
        }
      </div>
      <div class="footer-controls">
        <app-button-container>
          <app-button
            type="tertiary"
            [dataTestId]="'mfa-cancel'"
            (click)="cancelMultiFactorChallenge()"
            >Cancel</app-button
            >
            <app-button
              type="primary"
              [dataTestId]="'mfa-continue'"
              (click)="createMultiFactorChallenge()"
              >Continue</app-button
              >
            </app-button-container>
          </div>
        </div>
      } @else {
        @if ((challengeCompleteLoading$ | async) === false) {
          <div>
            @if ((currentlySelectedChallengeType$ | async) !== 'Email') {
              <p
                class="message"
                data-private
                >
                {{ packageUser.firstName }} {{ packageUser.lastName }}, please enter your security
                code.
              </p>
            }
            @if ((currentlySelectedChallengeType$ | async) === 'Email') {
              <p
                class="message"
                data-private
                >
                {{ packageUser.firstName }} {{ packageUser.lastName }}, please enter your security
                code. If you haven't received your security code, please check your junk/spam folder.
              </p>
            }
            <div class="mfa-challenge__input-wrapper">
              <app-password-input
                data-private
                [dataTestId]="'mfa-enter'"
                [errorMessage]="challengeCodeErrorMessage"
                [formControlRef]="challengeCode"
                [inputmode]="'numeric'"
                [label]="'Security code'"
                >
              </app-password-input>
              <app-button
                type="tertiary"
                [dataTestId]="'mfa-resend'"
                (click)="resendMultiFactorChallenge()"
                >Resend Code</app-button
                >
              </div>
              @if (
                userCodeValidationState !== codeValidationStates.hide &&
                userCodeValidationState === codeValidationStates.invalid
                ) {
                <p
                  class="error resend-code-status"
                  >
                  Please wait {{ intervalTimer.getRemainingSeconds() }} seconds before requesting another
                  code.
                </p>
              }
              @if (
                userCodeValidationState !== codeValidationStates.hide &&
                userCodeValidationState === codeValidationStates.valid
                ) {
                <p
                  class="valid resend-code-status"
                  >
                  Code sent successfully.
                </p>
              }
              <div class="footer-controls">
                <app-button-container>
                  <app-button
                    type="secondary"
                    [dataTestId]="'mfa-challenge-cancel'"
                    (click)="cancelMultiFactorChallenge()"
                    >Cancel</app-button
                    >
                    <app-button
                      type="primary"
                      [dataTestId]="'mfa-challenge-next'"
                      (click)="completeMultiFactorChallenge()"
                      >Continue</app-button
                      >
                    </app-button-container>
                  </div>
                </div>
              }
              @if ((challengeCompleteLoading$ | async) === true) {
                <div class="spinner-container">
                  <app-generic-spinner> </app-generic-spinner>
                </div>
              }
            }
          </div>
